import './styles.css'
import { useSnapshot } from 'valtio'
import { useEffect, useRef, useCallback } from 'react'
import { state } from '../store'

export default function Overlay() {
  const { colors, selectedColor } = useSnapshot(state)
  const audioRef = useRef(null)
  const musicButtonRef = useRef(null)
  const isPlayingRef = useRef(false)

  const handleNavClick = useCallback((e) => {
    e.preventDefault()
    const href = e.currentTarget.getAttribute('href')
    const target = document.querySelector(href)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    const audio = audioRef.current
    const musicButton = musicButtonRef.current
    if (!audio || !musicButton) return

    const toggleMusic = () => {
      if (!isPlayingRef.current) {
        audio.play().then(() => {
          musicButton.textContent = 'PAUSE'
          isPlayingRef.current = true
        }).catch((err) => {
          console.error('Audio play error:', err)
        })
      } else {
        audio.pause()
        musicButton.textContent = 'PLAY'
        isPlayingRef.current = false
      }
    }

    musicButton.addEventListener('click', toggleMusic)

    return () => {
      musicButton.removeEventListener('click', toggleMusic)
    }
  }, [])

  return (
    <div className="container">

      <header>
        <div className="brand">
          <img src="/logo.svg" alt="Suzuki Logo" width='45' height='35' />
          <p>
            SUZUKI <strong>GSX 750</strong>
          </p>
        </div>

        <nav className='header-nav'>
          <ul>
            <li><a href="#home" onClick={handleNavClick}>Home</a></li>
            <li><a href="#store" onClick={handleNavClick}>Store</a></li>
            <li><a href="#products" onClick={handleNavClick}>Products</a></li>
            <li><a href="#contact" onClick={handleNavClick}>Contact</a></li>
          </ul>
        </nav>

        <button ref={musicButtonRef}>SOUND</button>
        <audio ref={audioRef} src="/music.mp3" preload="auto" loop></audio>
      </header>

      <div className="main-wrapper">
        <section className="section section-1" id="home">
          <div className='section-1-wrapper'>
            <h1 className='section-1-title'>Suzuki GSX</h1>
            <p className='section-1-text'>01</p>
          </div>
        </section>

        <section className="section section-2">
          <div className="section-2-wrapper">
            <h1>GSX 750CC</h1>
            <div className='section-2-info'>
              <h2>Advanced Lighting and Tools</h2>
              <p>Inspired by Andrea Carrea's heroic story, we sat down to design our second stationary bike. First, we called on our woodworkers to create a striking, tough-looking handlebar. Then, we designed an all-new leather saddle and found some great retro tires made by Schwalbe.</p>
            </div>
          </div>
        </section>

        <section className="section section-3" id="products">
          <div className="section-3-wrapper">
            <div className='section-3-info-wrapper'>
              <h2>Radial Tires And <br /> 6-Spoke Wheels</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
            </div>
            <img src="/bike.jpg" alt="Suzuki GSX 750 radial tires and 6-spoke wheels detail" width='500' height='320' />
          </div>
        </section>

        <section className="section section-4">
          <div className="section-4-wrapper">
            <div className='section-4-info-wrapper'>
              <h2>A Chassis With <br /> A Lighter Frame</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
            </div>
            <img src="/bikee.jpg" alt="Suzuki GSX 750 lightweight chassis frame" width='500' height='320' />
          </div>
        </section>

        <section className="section section-5" id="store">
          <div className="section-5-wrapper">
            <div className="bike-power">
              <div className="bike-power-info">
                <h2>Suzuki GSX750 <strong> &euro;9100.00</strong></h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut. Labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
              </div>
              <div className="bike-power-stats">
                <p><strong>1750 cc</strong><br /> ENGINE</p>
                <p><strong>290 kmph</strong><br /> MAX SPEED</p>
                <p><strong>64kW</strong><br /> BHP</p>
                <p><strong>120nM</strong><br /> TORQUE</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section section-6">
          <div className='section-6-wrapper'>
            <div className='section-6-info-wrapper'>
              <h2>Color</h2>
              <p>Choose your favorite color :</p>
            </div>
            <div className='section-6-colors-wrapper'>
              <ul>
                {colors.map((color) => (
                  <li
                    key={color}
                    style={{ backgroundColor: color }}
                    className={selectedColor === color ? 'selected' : ''}
                    onClick={() => (state.selectedColor = color)}
                    aria-label={`Select color ${color}`}
                  >
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="section section-7">
          <div className="section-7-wrapper">
            <img src="/22.jpg" alt="Suzuki GSX 750 full showcase view" width='800' height='550' />
          </div>
        </section>

      </div>

      <footer id="contact">
        <div className="footer-left">
          <div className='footer-info-wrapper'>
            <div className="footer-column">
              <h3>About :</h3>
              <ul>
                <li><a href="#home" onClick={handleNavClick}>Home</a></li>
                <li><a href="#store" onClick={handleNavClick}>Store</a></li>
                <li><a href="#products" onClick={handleNavClick}>Products</a></li>
                <li><a href="#contact" onClick={handleNavClick}>Contacts</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Legal :</h3>
              <ul>
                <li><a href="#news">News</a></li>
                <li><a href="#terms">Terms and Conditions</a></li>
                <li><a href="#privacy">Privacy Policy</a></li>
                <li><a href="#cookies">Cookie Policy</a></li>
              </ul>
            </div>
          </div>
          <div className='footer-h2'>
            <img src="/logo.svg" alt="Suzuki Logo" width='50' height='50' />
            <h2>Suzuki GSX750</h2>
          </div>
          <p className="copyright">All rights reserved &copy; 2025 by Unfor Dev</p>
        </div>
      </footer>
    </div>
  )
}
